<template>
  <div ref="container" style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto;"
       :style="{ width: width, height: height }"
  >
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import { PieChart } from 'echarts/charts'
import { SVGRenderer } from 'echarts/renderers'
import { TooltipComponent } from 'echarts/components'
import resizeMixin from './resizeMixin'

echarts.use([PieChart, SVGRenderer, TooltipComponent])

export default {
  name: 'PieChart',
  mixins: [resizeMixin],
  props: {
    seriesData: {
      type: Array,
      default () {
        return []
      }
    },
    width: {
      type: String,
      default () {
        return '150px'
      }
    },
    height: {
      type: String,
      default () {
        return '150px'
      }
    },
    tooltipFormater: {
      type: [String, Function],
      required: false,
      default () {
        return undefined
      }
    },
    tooltipClass: {
      type: String,
      default () {
        return undefined
      }
    }
  },
  data () {
    return {
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 20,
          top: '30%',
          itemWidth: 22
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderRadius: 8
            },
            data: []
          }
        ]
      }
    }
  },
  created () {
    this.$on('render', (seriesData) => {
      this.option.series[0].data = seriesData
      this.chart && this.chart.setOption(this.option)
    })
  },
  mounted () {
    if (this.tooltipFormater) {
      this.option.tooltip.formatter = this.tooltipFormater
    }
    if (this.tooltipClass) {
      this.option.tooltip.className = this.tooltipClass
    }
    this.$nextTick(() => {
      const chartDom = this.$refs.container
      this.chart = echarts.init(chartDom)
      this.option.series[0].data = this.seriesData
      this.chart.setOption(this.option)
    })
  },
  updated () {
    this.option.series[0].data = this.seriesData
    this.chart.setOption(this.option)
  }
}
</script>
